import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../../_hooks/useClientId';
import { BeneficiaryDTO } from './useAccountsQuery';

export interface AccountBeneficiariesParams {
  AccountId: string;
  Beneficiaries: BeneficiaryDTO[];
  LastBeneficiaryUpdate: string | null;
  clientId: number;
}

const accountBeneficiariesSave = ({ clientId }: Pick<AccountBeneficiariesParams, 'clientId'>) => (
  params: Omit<AccountBeneficiariesParams, 'clientId'>,
) =>
  authFetch('/Consumer/AccountBeneficiariesUpdate/Save', {
    method: 'POST',
    ...httpBodyOptions(
      {
        ...params,
        clientId,
        id: params.AccountId,
      },
      true,
    ),
  });

export const useAccountBeneficiariesMutation = () => {
  const clientId = useClientId();

  return useMutation(accountBeneficiariesSave({ clientId }));
};
